import React from 'react'
import { graphql, HeadProps } from 'gatsby'
import { CommonHead, ProsByTitle, ProsLayout } from '../../../components'
import { LandingPageQuery } from '../../../app-types'

export const Head = ({ data, location }: HeadProps<LandingPageQuery>) => {
  return (
    <>
      <CommonHead
        title={`Find Hospitality Jobs & Skilled Talent with Qwick App | Fast & Easy`}
        description="Looking for hospitality jobs or talent? Qwick is the leading marketplace app to connect you with top professionals for events, restaurants, and more. Download now!"
        url={data.site.siteMetadata.siteUrl + location.pathname}
      />
    </>
  )
}

const PageProsByRoles = () => {
  return (
    <ProsLayout>
      <ProsByTitle urlPath="/browse-pros/roles" />
    </ProsLayout>
  )
}

export const data = graphql`
  query pageQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
    allMarketCity {
      nodes {
        id
        city
        gigProID
        market {
          state
        }
      }
    }
    allMarketState {
      nodes {
        id
        state
      }
    }
  }
`

export default PageProsByRoles
